import { styled } from '@mui/material';
import { colorPalettes } from '../../../../context/theme';

export const StyledSeparator = styled.div`
  border-bottom: 1px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.accountSettings.separator};
`;
